import CKEditor from 'ckeditor4-vue'
import Vue, { PluginObject } from 'vue'

export const CKEditorPlugin: PluginObject<undefined> = {
  install() {
    Vue.use(CKEditor)
  },
}
